import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-available-media-s3-control',
  templateUrl: './available-media-s3.component.html',
  styleUrls: ['./available-media-s3.component.scss']
})
export class AvailableMediaS3ControlComponent {

  constructor(
    public dialogRef: MatDialogRef<AvailableMediaS3ControlComponent>
  ) { }

  dialogAction(isContinue: boolean) {
		return this.dialogRef.close(isContinue);
  }
}
